export enum CommutePopupStatus {
 Initial = 'INITIAL',
 Open = 'OPEN',
 Closed = 'CLOSED',
 Resolved = 'RESOLVED',
}
